import { render, staticRenderFns } from "./NotificationConsultantApprovalRequestForm.vue?vue&type=template&id=81bb016c"
import script from "./NotificationConsultantApprovalRequestForm.vue?vue&type=script&lang=js"
export * from "./NotificationConsultantApprovalRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports